import { defineComponent as s, computed as e, openBlock as t, createElementBlock as f, createElementVNode as l, toDisplayString as h, createCommentVNode as d, normalizeStyle as x, createStaticVNode as n } from "vue";
const p = ["viewBox"], y = /* @__PURE__ */ l("mask", { id: "1d95aa2c-2038-4468-88c3-f239036ab8cf" }, [
  /* @__PURE__ */ l("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#1d95aa2c-2038-4468-88c3-f239036ab8cf)" }, v = { key: 0 }, _ = /* @__PURE__ */ n('<path fill="#eee" d="M0 0h256l256 57v57l-32 28 32 29v57l-32 28 32 29v56l-32 29 32 28v57l-256 29L0 455v-57l32-28-32-29v-56l32-29-32-28Z"></path><path fill="#333" d="M256 0h256v57H256zm0 114h256v57H256zM0 228h512v57H0zm0 113h512v57H0zm0 114h512v57H0zM16 72l19 14 19-14-19-40z"></path><circle cx="46.7" cy="32.4" r="6" fill="#333"></circle><circle cx="22.7" cy="32.4" r="6" fill="#333"></circle><circle cx="34.7" cy="20.4" r="6" fill="#333"></circle><path fill="#333" d="m109 72 19 14 19-14-19-40z"></path><circle cx="140.4" cy="32.4" r="6" fill="#333"></circle><circle cx="116.4" cy="32.4" r="6" fill="#333"></circle><circle cx="128.4" cy="20.4" r="6" fill="#333"></circle><path fill="#333" d="m203 72 19 14 19-14-19-40z"></path><circle cx="234.1" cy="32.4" r="6" fill="#333"></circle><circle cx="210.1" cy="32.4" r="6" fill="#333"></circle><circle cx="222.1" cy="20.4" r="6" fill="#333"></circle><path fill="#333" d="m156 138 19 14 19-14-19-40z"></path><circle cx="187.2" cy="98.2" r="6" fill="#333"></circle><circle cx="163.2" cy="98.2" r="6" fill="#333"></circle><circle cx="175.2" cy="86.2" r="6" fill="#333"></circle><path fill="#333" d="m63 138 19 14 18-14-18-40z"></path><circle cx="93.5" cy="98.2" r="6" fill="#333"></circle><circle cx="69.5" cy="98.2" r="6" fill="#333"></circle><circle cx="81.5" cy="86.2" r="6" fill="#333"></circle><path fill="#333" d="m16 204 19 14 19-14-19-40z"></path><circle cx="46.7" cy="164" r="6" fill="#333"></circle><circle cx="22.7" cy="164" r="6" fill="#333"></circle><circle cx="34.7" cy="152" r="6" fill="#333"></circle><path fill="#333" d="m109 204 19 14 19-14-19-40z"></path><circle cx="140.4" cy="164" r="6" fill="#333"></circle><circle cx="116.4" cy="164" r="6" fill="#333"></circle><circle cx="128.4" cy="152" r="6" fill="#333"></circle><path fill="#333" d="m203 204 19 14 19-14-19-40z"></path><circle cx="234.1" cy="164" r="6" fill="#333"></circle><circle cx="210.1" cy="164" r="6" fill="#333"></circle><circle cx="222.1" cy="152" r="6" fill="#333"></circle>', 33), k = { fill: "none" }, u = ["r"], N = /* @__PURE__ */ s({
  __name: "fr-bre",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(o) {
    const c = o, i = e(() => 512 + 2 * c.strokeWidth), r = e(() => -c.strokeWidth), a = e(() => 256 + c.strokeWidth / 2);
    return (z, g) => (t(), f("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${r.value} ${r.value} ${i.value} ${i.value}`
    }, [
      y,
      l("g", m, [
        c.flagName ? (t(), f("title", v, h(c.flagName), 1)) : d("", !0),
        _
      ]),
      l("g", k, [
        l("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: x({ stroke: c.strokeColor, strokeWidth: c.strokeWidth })
        }, null, 12, u)
      ])
    ], 8, p));
  }
});
export {
  N as default
};
//# sourceMappingURL=fr-bre-e4677c49.js.map
